import { useEffect } from 'react';
import useNavigateWithEnv from 'shared/hooks/useNavigateWithEnv';

const NavigateWithEnv = ({
  to,
  replace,
}: {
  to: string;
  replace?: boolean;
}) => {
  const navigate = useNavigateWithEnv();

  useEffect(() => {
    navigate(to, { replace });
  }, [navigate, to, replace]);

  return null;
};

export default NavigateWithEnv;
